export const SHIPMENT_HISTORY_LOAD = 'SHIPMENT_HISTORY_LOAD_INITIAL_DATA';
export const SHIPMENT_HISTORY_FILTER = 'SHIPMENT_HISTORY_FILTER';



// WEBPACK FOOTER //
// ./src/app/store/actions/shipment-history.action.ts